import { NewNames as NewNamesForm } from '@bgea-js/form-templates';
import customConfirmationWillRedeemed from "../../../../src/content/will-graham-redeemed/customConfirmation";
import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/will-graham-redeemed/will-redeemed.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  customConfirmationWillRedeemed,
  SingleDonationForm,
  React
};